"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const input_1 = __importDefault(require("@kyruus/input"));
const button_1 = __importDefault(require("@kyruus/button"));
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const FileInput = (props) => {
    var _a;
    const { path, label, disabled } = props;
    const eventProcessor = (e) => { var _a; return ((_a = e === null || e === void 0 ? void 0 : e.target.files) === null || _a === void 0 ? void 0 : _a.length) ? e.target.files.item(0) : null; };
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor
    });
    const { AddOn, config } = state;
    if (!config.isVisible)
        return null;
    if (config.isReadOnly) {
        return react_1.default.createElement(read_only_1.default, { msg: ((_a = state.value) === null || _a === void 0 ? void 0 : _a.name) ? state.value.name : '' });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: !!state.errors.length },
            state.value && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ImagePreview, { value: state.value }),
                react_1.default.createElement(styles_1.Text, null, state.value.name),
                react_1.default.createElement("br", null),
                react_1.default.createElement(button_1.default, { onClick: () => actions.onChange(null) }, "Remove"))),
            !state.value && (react_1.default.createElement(input_1.default, { type: "file", accept: config.accept, errors: state.errors, required: config.isRequired, onChange: actions.onChange, placeholder: config.placeholder, disabled: config.isReadOnly || disabled, name: path, "data-testid": path, label: config.label || label || '', id: path, hideLabel: true, maxLength: config.maxLength, displayCharacterCount: config.displayCharacterCount, characterCountReachedMessage: config.characterCountReachedMessage }))),
        react_1.default.createElement(AddOn, null)));
};
exports.default = FileInput;
exports.defaultConfig = {};
function ImagePreview(props) {
    return (props.value.type.match(/image\//) && (react_1.default.createElement("img", { style: { maxHeight: '100px', width: 'auto' }, alt: props.value.name, src: URL.createObjectURL(props.value) })));
}
//# sourceMappingURL=index.js.map